
const ScopeTokenValues = {
    BeginScope: 0,
    EndScope: 1,
    ClosedScope: 2,
    Translate: function (scopeTokenValue) {

        switch(scopeTokenValue) {
            case 0:
                return "BeginScope";
            case 1:
                return "EndScope";
            case 2:
                return "ClosedScope";
            default:
                throw new TypeError("Invalid Scope Token Value");
        }
    }
};



export default Object.freeze(ScopeTokenValues);


    


//////////////////
// WEBPACK FOOTER
// ./src/models/parser-tokens/ScopeTokenValues.js
// module id = N8Sd
// module chunks = 1